import script from "./AddCatalogModalSelectableArea.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCatalogModalSelectableArea.vue?vue&type=script&setup=true&lang=js"

import "./AddCatalogModalSelectableArea.vue?vue&type=style&index=0&id=85451676&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85451676"]])

export default __exports__